import { useEmbedStore } from './embedStore';

export const DATA_REFRESH_EVENT = 'dp:refresh-data';

/**
 * Rafraîchissement après une mutation réussie.
 *
 * En iframe (Arsenal/BPM), un `window.location.reload()` fige la hauteur du cadre côté parent :
 * le nouveau document renvoie sa hauteur une seule fois et, si ce message est manqué, plus rien
 * ne bouge — le cadre reste trop court et le scroll tactile de la page parente est bloqué
 * jusqu'à ce que le parent recharge l'iframe. On demande donc à la page montée de recharger
 * ses données au lieu de recharger le document.
 */
export function reloadAfterMutation(): void {
  if (typeof window === 'undefined') return;

  if (useEmbedStore.getState().isEmbed) {
    window.dispatchEvent(new CustomEvent(DATA_REFRESH_EVENT));
    return;
  }

  window.location.reload();
}
